module.exports = __webpack_public_path__ + "static/media/error-red.b0b10395.svg";